import { supabase } from "./supabase";

const path = window.location.pathname;
const isEnglish = path.includes("/en/");

async function getNews() {
  let { data, error } = await supabase
    .from("news")
    .select(
      "id, created_at, title, pdf, number, draft, uuid, date, news_en (pdf)"
    )
    .neq("draft", true)
    .order("date", { ascending: false });

  if (error) {
    console.log(error);
    return;
  }

  if (isEnglish) {
    const newsList = new Array();

    data.forEach((news) => {
      if (news.news_en.length > 0) {
        newsList.push(news);
      }
    });

    renderNews(newsList);
  } else {
    renderNews(data);
  }
}

getNews();

function renderNews(newsData) {
  function sortByDateAndGroup(newsData) {
    const groupedAndSortedData = [];

    newsData.forEach((item) => {
      const year = item.date.split("-")[0];
      let yearData = groupedAndSortedData.find((data) => data.year === year);

      if (!yearData) {
        yearData = { year, data: [] };
        groupedAndSortedData.push(yearData);
      }

      yearData.data.push(item);
    });

    // Sort items within each year by date
    groupedAndSortedData.forEach((yearData) => {
      yearData.data = yearData.data.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
    });

    return groupedAndSortedData;
  }

  const groupedAndSortedData = sortByDateAndGroup(newsData);

  // Iterate over the grouped and sorted data
  groupedAndSortedData.forEach((yearData) => {
    const years_sorting = document.getElementById("years-sorting");
    years_sorting.innerHTML += `
        <li><a href="?year=${yearData.year}" class="hover:text-zinc-500 duration-300 transition-all" id="year${yearData.year}">${yearData.year}</a></li>
        `;

    let string = "";
    const container = document.getElementById("post-container");
    string =
      string +
      `
        <div class="mb-12 display-sorting" data-year="${yearData.year}">
        <h1 class="font-poppins font-semibold text-4xl mb-3">${yearData.year}</h1>
        <div class="flex flex-wrap columns-1 gap-5 md:columns-2 lg:columns-3">
        `;

    yearData.data.forEach((item) => {
      const date = new Date(item.date);
      const year = date.getUTCFullYear();
      string =
        string +
        `
          <a  href="${
            isEnglish ? item.news_en[0].pdf : item.pdf
          }" target="_blank" rel="noopener noreferrer"
            class="w-full sm:w-[46%] md:w-[30%] bg-white border border-black rounded-md hover:scale-[1.03] hover:rotate-[-0.5deg] transition-all duration-500">
            <div class="py-3 px-4 min-h-full flex-col flex">
              <h5 class="text-xl font-semibold text-black font-poppins mb-0">${
                item.title
              }, Nr. ${item.number}</h5>
              <h5 class="text-lg font-medium text-black font-poppins mt-auto">${
                isEnglish
                  ? date.toLocaleDateString("en-EN", { month: "long" })
                  : date.toLocaleDateString("de-DE", { month: "long" }) +
                    ", " +
                    year
              }</h5>
            </div>
          </a>
        `;
    });
    string =
      string +
      `
            </div>
        </div>
        `;
    container.innerHTML += string;
  });
  runFilterCheck();
}

// Function to filter posts by year and style selected anchor
function filterPostsByYear(year, yearAnchor) {
  const posts = document.querySelectorAll("#post-container > *");
  posts.forEach((post) => {
    if (post.getAttribute("data-year") != year) {
      post.classList.add("hidden");
      yearAnchor.classList.add("underline");
      document.getElementById("year-all").classList.remove("underline");
    }
  });
}

// Check for year parameter in URL and filter posts
function runFilterCheck() {
  const urlParams = new URLSearchParams(window.location.search);
  const yearParam = urlParams.get("year");

  const yearAnchor = document.getElementById(`year${yearParam}`);

  if (yearParam) {
    filterPostsByYear(yearParam, yearAnchor);
  }
}
